export abstract class AutorizzazioneAuthGuard {
  protected readonly URL_NON_AUTORIZZATO: string = '/nonautorizzato'
}
